import { gearsMeta } from "@made-people/gears-remix";
import { getLoaderCustomExtraDataOrNull } from "../utils/loader-custom-extra-data";
import { rewriteUrlDomainBySiteSlug } from "./raw-response-routes/rewrite-sitemap-loc-domains";

/**
 * Start with the default meta output, then point alternate hreflang links and canonical link
 * at the market-specific domains. Adds noindex for non-canonical market URLs:
 * - .com pages with a market slug that has its own domain (e.g. missmary.com/se)
 * - Market domains serving a different market's content (e.g. missmary.se/de)
 */
export const missMaryMeta: typeof gearsMeta = (ctx) => {
  const meta = gearsMeta(ctx);
  const customExtraData = getLoaderCustomExtraDataOrNull(
    (ctx.data as Record<string, unknown>)?.customExtraData,
  );
  const shouldNoIndex = customExtraData?.shouldNoIndex ?? false;

  const result = meta.map((entry) => {
    if (
      "href" in entry &&
      typeof entry.href === "string" &&
      "rel" in entry &&
      (entry.rel === "alternate" || entry.rel === "canonical")
    ) {
      return { ...entry, href: rewriteUrlDomainBySiteSlug(entry.href) };
    }
    return entry;
  });

  if (shouldNoIndex) {
    const robotsIdx = result.findIndex(
      (e) => "name" in e && e.name === "robots",
    );
    if (robotsIdx >= 0) {
      const existing = result[robotsIdx] as { name: string; content: string };
      if (!existing.content.includes("noindex")) {
        result[robotsIdx] = {
          ...existing,
          content: `noindex,${existing.content}`,
        };
      }
    } else {
      result.push({ name: "robots", content: "noindex" });
    }
  }

  return result;
};
